// extracted by mini-css-extract-plugin
export default {"mixes_well_item":"f4","mixes_well_item_wide":"g4","mixes_well_item__title":"h4","mixes_well_item__image":"i4"};
    if(module.hot) {
      // 1711394580385
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  